import { Image } from "@chakra-ui/react";
import React from "react";
import { circleSuperIcon } from "../../assets/images";

export const MenuButton: React.FC = () => {
  return <Image src={circleSuperIcon} alt={"Ícone de menu"} />;
};
